var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"1 1 3 3"}},[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M2 1h1v1h1v1H3v1H2V3H1V2h1z"}})])
}
var staticRenderFns = []

export default { render: render }